import { alpha, type Theme } from '@mui/material/styles';

const actionButtonSx = {
  boxShadow: 6,
  border: 2,
  borderStyle: 'solid',
} as const;

export function saveButtonSx(theme: Theme) {
  return {
    ...actionButtonSx,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderColor: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  };
}

export function cancelButtonSx(theme: Theme) {
  return {
    ...actionButtonSx,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.1),
    },
  };
}
